// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"825":"tws-breadcrumb-container","903":"tws-pebble-background-container"}[chunkId] + "." + {"825":"43c5c612","903":"b71a8a10"}[chunkId] + ".js";
};